import { render, staticRenderFns } from "./TransactionDetailsPage.vue?vue&type=template&id=2cce60f5&scoped=true&"
import script from "./TransactionDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailsPage.vue?vue&type=style&index=0&id=2cce60f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce60f5",
  null
  
)

export default component.exports